import '../../styles/theme-enhancements.css';

const STORAGE_KEY = 'znzi-theme';
const LIGHT_THEME_COLOR = '#f7f5fb';
const DARK_THEME_COLOR = '#07060a';

function normalizeTheme(value) {
  return value === 'light' ? 'light' : 'dark';
}

export default class ThemeManager {
  constructor() {
    this.currentTheme = 'dark';
    this.buttons = [];
  }

  init() {
    this.buttons = [...document.querySelectorAll('[data-theme-toggle]')];
    this.applyTheme(this.readTheme(), false);

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const nextTheme = this.currentTheme === 'dark' ? 'light' : 'dark';
        this.applyTheme(nextTheme, true);
      });
    });

    window.addEventListener('storage', (event) => {
      if (event.key === STORAGE_KEY) {
        this.applyTheme(event.newValue, false);
      }
    });
  }

  readTheme() {
    try {
      return normalizeTheme(window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return 'dark';
    }
  }

  applyTheme(value, persist) {
    const theme = normalizeTheme(value);
    const isDark = theme === 'dark';
    this.currentTheme = theme;
    document.documentElement.dataset.theme = theme;

    const themeColor = document.querySelector('meta[name="theme-color"]');
    themeColor?.setAttribute('content', isDark ? DARK_THEME_COLOR : LIGHT_THEME_COLOR);

    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', isDark ? 'Modo oscuro. Activar modo claro' : 'Modo claro. Activar modo oscuro');
      const label = button.querySelector('[data-theme-label]');
      if (label) label.textContent = isDark ? 'Oscuro' : 'Claro';
    });

    if (persist) {
      try {
        window.localStorage.setItem(STORAGE_KEY, theme);
      } catch (error) {
        // The selected theme remains active even if storage is unavailable.
      }
    }
  }
}
